import axios from 'axios'
import library from '../../../../utils/Library'

export const enableMEFullVersionEAutz = async (selectedFile) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('e_authz') + '/enableMEFullVersionEAuthz'

  const formData = new FormData()
  formData.append('file', selectedFile)
  return await axios.post(URL, formData, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
